/**
 * Created by chenzheyu on 2017/6/7.
 */
import Vue from 'vue'
import GPS from './gps'
import CryptoJS from 'crypto-js'
import init from '../../store/modules/initdata'
import Cookie from 'js-cookie'
import JSONBig from 'json-bigint-xk'

let Toucth = {
  slide: (dom, Fn) => {
    dom.addEventListener('touchstart', function (event) {
      let left = event.targetTouches[0].clientX
      let top = event.targetTouches[0].clientY
      let state = true
      let direction = ''
      if (left > 30 && left < (document.body.offsetWidth) - 30) {
        dom.addEventListener('touchmove', function (event) {
          if (state) {
            let Xstate = left - event.targetTouches[0].clientX
            let Ystate = top - event.targetTouches[0].clientY
            if (Xstate < -50 && Ystate < 15 && Ystate > -15) {
              state = false
              direction = 'right'
              if (Fn) {
                Fn(direction)
              }
            } else if (Xstate > 50 && Ystate < 15 && Ystate > -15) {
              state = false
              direction = 'left'
              if (Fn) {
                Fn(direction)
              }
            } else if (Ystate > 50 && Xstate < 15 && Xstate > -15) {
              state = false
              direction = 'up'
              if (Fn) {
                Fn(direction)
              }
            } else if (Ystate < -50 && Xstate < 30 && Xstate > -30) {
              state = false
              direction = 'down'
              if (Fn) {
                Fn(direction)
              }
            }
          }
        }, true)
      }
    }, true)
  },
  getCookie (name) { // 获取 Cookie
    let arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
    if (arr != null) {
      return unescape(arr[2])
    }
    return null
  },
  setCookie (name, value, time) { // 设置 Cookie
    let Days = time // 此 cookie 将被保存 30 天
    let exp = new Date()    // new Date("December 31, 9998");
    exp.setTime(exp.getTime() + Days * 60 * 60 * 1000)
    if ((typeof value === 'string') && (value.length > 0)) {
      document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
    } else {
      let exp = new Date()
      exp.setTime(exp.getTime() - 1)
      let cval = this.getCookie(name)
      if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
    }
  },
  delCookie (name) { // 删除 Cookie
    let exp = new Date()
    exp.setTime(exp.getTime() - 1)
    let cval = this.getCookie(name)
    if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  },
  touchstart: (dom, Fn) => {
    dom.addEventListener('touchstart', function (event) {
      Fn(event)
    })
  },
  touchmove: (dom, Fn) => {
    dom.addEventListener('touchmove', function (event) {
      Fn(event)
    })
  },
  gainStyle: (mod, val, replaceText) => {
    let computedStyle = window.getComputedStyle(mod)
    let result = computedStyle[val]
    if (replaceText) {
      result = result.replace(replaceText, '')
    }
    return result
  },
  checkPhone: (Phone) => { // 判断手机号
    // let myreg = /^(((1[0-9]{2}))+\d{8})$/
    let myreg = /^\d{11}$/
    if (!myreg.test(Phone)) {
      return false
    } else {
      return true
    }
  },
  AcquireUrlParameter: () => { // 获取URL 的参
    let url = location.hash // 获取url中"?"符后的字串
    let UrlObj = {}
    if (url.indexOf('?') !== -1) {
      url = url.split('?')[1]
      url = url.replace('?', '')
      url = url.split('&')
      for (let i = 0; i < url.length; i++) {
        (function () {
          let index = i
          let urls = url[index]
          UrlObj[urls.split('=')[0]] = urls.split('=')[1]
        })()
      }
    } else {
      UrlObj = '当前URL无传参！'
    }
    return UrlObj
  },
  TimestampDate: function (stringTimestamp) { // 时间戳转时间
    if (typeof stringTimestamp === 'string') {
      stringTimestamp = stringTimestamp.replace('-', '/')
      stringTimestamp = stringTimestamp.replace('-', '/')
    }
    if (String(stringTimestamp).length === 10) {
      stringTimestamp *= 1000
    }
    let time = new Date(stringTimestamp)

    let Check = (obj) => {
      if (obj < 10) {
        return ('0' + obj)
      }
      return obj
    }

    let y = time.getFullYear()// 年
    let m = time.getMonth() + 1// 月
    let d = time.getDate()// 日
    let h = time.getHours()// 时
    let mm = time.getMinutes()// 分

    let DataText = (y + '-' + Check(m) + '-' + Check(d) + ' ' + Check(h) + ':' + Check(mm))
    return DataText
  },
  GoogleEncrypt: function (positioning) { // Google坐标转换
    let gcjLat = positioning.lat
    let gcjLon = positioning.lng

    function outOfChina (lat, lon) {
      if (lon < 72.004 || lon > 137.8347) {
        return true
      }
      if (lat < 0.8293 || lat > 55.8271) {
        return true
      }
      return false
    }

    if (outOfChina(gcjLat, gcjLon)) {
      return {'lat': gcjLat, 'lng': gcjLon}
    }
    let d = this.delta(gcjLat, gcjLon)
    return {'lat': gcjLat - d.lat, 'lng': gcjLon - d.lon}
  },
  amapCoordinateFn: GPS.gcj_encrypt, // 原坐标转化 高德坐标
  ismobile: function (test) { // 判断是不是移动端
    let u = navigator.userAgent
    // let app = navigator.appVersion
    if (/AppleWebKit.*Mobile/i.test(navigator.userAgent) || (/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent))) {
      if (window.location.href.indexOf('?mobile') < 0) {
        try {
          if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
            return '0'
          } else {
            return '1'
          }
        } catch (e) {
        }
      }
    } else if (u.indexOf('iPad') > -1) {
      return '0'
    } else {
      return '1'
    }
  },
  IndividuationDate: function (stringTimestamp) { // 时间美化
    let stringTimestampS = stringTimestamp.length === 11 ? (stringTimestamp * 1000) : stringTimestamp
    let date = new Date(stringTimestampS)
    // let date = new Date()
    if ((date.valueOf() - stringTimestampS) <= 1800000) {
      return '刚刚'
    }
  },
  objKeySort: function (url, obj) { // 对象key排序 【对象，排序 false 正序 true 倒序】
    let params = {}
    for (let key in obj) {
      if (!key || key === 'fn' || key === 'app_key' || key === 'ad_code' || key === 'city_code' || key === 'timestamp' || key === 'company_id' || key === 'company_name') {
      } else {
        params[key] = obj[key]
      }
    }
    if (obj.ad_code) {
      if (window.configure.location && window.configure.location.ad_code) {
        params['ad_code'] = window.configure.location.ad_code
      } else {
        params['ad_code'] = '510100'
      }
    }
    if (obj.city_code) {
      if (window.configure.location && window.configure.location.city_code) {
        params['city_code'] = window.configure.location.city_code
      } else {
        params['city_code'] = '028'
      }
    }
    let companyInfo = ''
    let passengerInfo = window.configure.passengerInfo
    if (Cookie.get('companyinfo')) {
      companyInfo = JSONBig.parse(Cookie.get('companyinfo'))
    } else if (window.configure.companyinfo) {
      companyInfo = window.configure.companyinfo
    } else if (init.state.companyInfo) {
      companyInfo = init.state.companyInfo
    }
    params['company_id'] = companyInfo.id
    params['company_name'] = companyInfo.company_name
    // passengerInfo
    if (passengerInfo) {
      params['passenger_id'] = passengerInfo.id
      params['passenger_name'] = passengerInfo.name
      if (!params.company_id || !params.company_name) {
        params['company_id'] = passengerInfo.company_id
        params['company_name'] = passengerInfo.company_name
      }
    }
    params['app_key'] = window.configure.appKey
    if (obj.timestamp) {
      params['timestamp'] = ~~(Date.now() / 1000)
    }
    if (obj.channel && obj.channel !== 'system' && obj.channel !== 5) {
      params['channel'] = 'wechat'
    }
    let newkey = Object.keys(params).sort()
    // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    let newObj = {} // 创建一个新的对象，用于存放排好序的键值对
    // let text = url + '?'
    for (let i = 0; i < newkey.length; i++) { // 遍历newkey数组
      // text += newkey[i] + '=' + params[newkey[i]] + (i >= (newkey.length - 1) ? '' : '&')
      newObj[newkey[i]] = params[newkey[i]] // 向新创建的对象中按照排好的顺序依次增加键值对
    }
    // console.log(sha256.hmac(window.configure.sha256_key, '/passenger/api/v1/company?ad_code=510115&app_key=1f462eb305a2417c9564f2dfaf89da9c&city_code=028&timestamp=1515988508380'))
    // console.log(text)
    return newObj // 返回排好序的新对象
  },
  objKeySync: function () { // 对象key排序 【对象，排序 false 正序 true 倒序】
    return new Promise(function (resolve, reject) {
      let params = {
        companyInfor: '',
        location: '',
        passenger: '',
        app_key: '',
        timestamp: null,
        channel: ''
      }
      // 公司信息
      if (window.configure.companyinfo) {
        params.companyInfor = window.configure.companyinfo
      } else if (init.state.companyInfo) {
        params.companyInfor = init.state.companyInfo
      } else if (window.configure.passengerInfo) {
        params.companyInfor = window.configure.passengerInfo
      } else {
        params.companyInfor = ''
      }
      // ad_code和city_code
      if (window.configure.location) {
        params.location = window.configure.location
      }
      // 用户信息
      if (window.configure.passengerInfo) {
        params.passenger = window.configure.passengerInfo
      }
      // appKey
      params.app_key = window.configure.appKey
      params.timestamp = ~~(Date.now() / 1000)
      params.channel = 'wechat'
      for (let key in params) {
        if (key && key !== '') {
          resolve(params)
        } else {
          reject(params)
        }
      }
    })
  },
  paramsAsync () {
    // let system = this.objKeySync
    // system.then(function (res) {
    // }, function (err) {
    // })
  },
  aesEncryptCode (phone) { // AES 加密
    let key = CryptoJS.enc.Utf8.parse('aaaaaaaaaaaaaaaa') // 加密的 钥匙

    let plaintText = phone + '' // 要加密的 文本

    let encryptedData = CryptoJS.AES.encrypt(plaintText, key, {  // 加密
      iv: key,  // 偏移量  和钥匙一样
      mode: CryptoJS.mode.CBC, // CBC 加密方法
      padding: CryptoJS.pad.Pkcs7 // PKcs7
    })
    return encryptedData.toString()
  },
  aesDecryptCode (phone) { // AES 解密
    let key = CryptoJS.enc.Utf8.parse('aaaaaaaaaaaaaaaa') // 解密的 钥匙

    let plaintText = phone + '' // 要解密的 文本

    let encryptedData = CryptoJS.AES.decrypt(plaintText, key, {  // 解密
      iv: key,  // 偏移量  和钥匙一样
      mode: CryptoJS.mode.CBC, // CBC 加密方法
      padding: CryptoJS.pad.Pkcs7 // PKcs7
    })
    return encryptedData.toString(CryptoJS.enc.Utf8).toString()
  },
  RandomNumBoth (Min, Max) { // 获取范围随机数  Min<= r <= Max
    let Range = Max - Min
    let Rand = Math.random()
    let num = Min + Math.round(Rand * Range) // 四舍五入
    return num
  },
  v5ZcOrderStatus (name) {
    switch (name) {
      case 1:
        return '新单'
      case 5:
        return '已派单'
      case 10:
        return '已接单'
      case 15:
        return '前往预约地'
      case 20:
        return '到达预约地'
      case 25:
        return '前往目的地'
      case 28:
        return '中途等待'
      case 30:
        return '到达目的地'
      case 35:
        return '已结算'
      case 40:
        return '已评价'
      case 45:
        return '已销单'
      default:
        return ''
    }
  }
}

Vue.prototype.$utils = Toucth

export default Toucth



// WEBPACK FOOTER //
// ./src/assets/js/method.js